import React from "react";
import PropTypes from "prop-types";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Tooltip, Legend);

const ASNMonthlyChart = ({ monthlyData }) => {
  const labels = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  const data = {
    labels,
    datasets: [
      {
        label: "Monthly ASN Orders",
        data: monthlyData,
        borderColor: "#1E88E5", // 👈 Line color
        backgroundColor: "#1E88E5", // 👈 Point fill color
        pointBorderColor: "#1E88E5", // 👈 Point border
        pointBackgroundColor: "#FFFFFF",
        borderWidth: 3,
        tension: 0.4,
        fill: false,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false, // ⬅ allows full height usage
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 50, // ⬅ add more visible steps
        },
        grid: {
          color: "#ddd",
        },
      },
      x: {
        grid: {
          display: true,
          color: "#eee",
        },
      },
    },
  };

  return (
    <div
      style={{
        height: "260px", // ⬅ sets full height inside card
        width: "100%",
      }}
    >
      <Line data={data} options={options} />
    </div>
  );
};

ASNMonthlyChart.propTypes = {
  monthlyData: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default ASNMonthlyChart;
